/* Small progressive enhancements; core navigation and forms work without JS. */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.ar-mobile-nav[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', (event) => {
    const menu = document.querySelector('.ar-mobile-nav[open]');
    if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
  });
})();
